/**
 * PURPOSE: Estado de los flags de opciones de uniforme normalizadas (FTR-0014) para toda la SPA.
 * RESPONSIBILITIES: Una sola consulta compartida (renovada al minuto) y un hook con { loading, enabled,
 *   publicEnabled }. Mientras carga, los editores legacy no deben ofrecer escritura.
 * COLLABORATORS: uniformOptionsService.js, AdminCompanySection.jsx, UniformMatrix.jsx, ModalEditUniform.jsx,
 *   ModalProgramacion.jsx, ProgramacionArea.jsx.
 * ROUTE: winscore/src/hooks/useUniformOptionsStatus.js
 */
import { useEffect, useState } from "react";

import { getUniformOptionsStatus } from "../services/uniformOptionsService.js";

const TTL_MS = 60 * 1000;
let cache = null;

export const loadUniformOptionsStatus = () => {
  if (!cache || Date.now() - cache.at > TTL_MS) cache = { at: Date.now(), promise: getUniformOptionsStatus() };
  return cache.promise;
};

export const useUniformOptionsStatus = () => {
  const [state, setState] = useState({ loading: true, enabled: false, publicEnabled: false });
  useEffect(() => {
    let active = true;
    loadUniformOptionsStatus().then((status) => {
      if (active) setState({ loading: false, ...status });
    });
    return () => {
      active = false;
    };
  }, []);
  return state;
};
